import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React, { Component } from 'react';
import { translate, Flex, Checkbox, Button } from '@haldor/ui';
import { connect } from 'react-redux';
import { Field, reduxForm, change } from 'redux-form';
import { getServices, setSelectedServices, createTenantServices, updateTenantServices, updateTenantProducts, saveSelectedProductsAsNotes, getTenantProducts } from '../../../actions/services';
import { getTenant, userAdminCheck } from '../../../actions/user';
import { Spinner } from 'UI';
import { appInsights } from 'lib/appInsights';

var ServiceSelector = /*#__PURE__*/function (_Component) {
  _inherits(ServiceSelector, _Component);

  var _super = _createSuper(ServiceSelector);

  function ServiceSelector(props) {
    var _this;

    _classCallCheck(this, ServiceSelector);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "submit", function (values) {
      return new Promise(function (resolve) {
        var keys = Object.keys(values);
        var selectedProducts = [];
        keys.forEach(function (title) {
          var found = _this.props.products.find(function (element) {
            return element.name === title;
          });

          if (found && values[title]) {
            selectedProducts.push(found);
          }
        });

        _this.props.setSelectedServices(selectedProducts);

        appInsights.trackTrace({
          message: "Onboarding | Collecting all selected services"
        }, {
          services: selectedProducts,
          tenant: _this.props.tenant
        });
        console.log("tenant", _this.props.tenant);

        if (_this.props.tenant != null) {
          var tenantServices = [];
          selectedProducts.forEach(function (selectedService) {
            selectedService.services.forEach(function (element) {
              if (!tenantServices.find(function (service) {
                return service.ServiceId == element.id;
              })) {
                tenantServices.push({
                  ServiceId: element.id
                });
              }
            });
          });
          appInsights.trackTrace({
            message: "Onboarding | trying update tenantProducts"
          }, {
            services: tenantServices,
            tenant: _this.props.tenant,
            products: selectedProducts
          }); // We need to store products on tenant level

          _this.props.updateTenantProducts(selectedProducts).then(function () {
            _this.props.getTenantProducts();

            appInsights.trackTrace({
              message: "Onboarding | trying update tenantServices"
            }, {
              services: tenantServices,
              tenant: _this.props.tenant
            }); // This is importanted since our system is depended on services

            _this.props.createTenantServices(tenantServices).then(function () {
              _this.props.saveSelectedProductsAsNotes(false);

              _this.props.getTenant();
            });
          });
        } else {
          appInsights.trackException({
            exception: new Error('Onboarding | No tenant was found to save selected products')
          });
        }

        if (_this.props.onSubmit) {
          _this.props.onSubmit(1).then(function () {
            resolve(1);
          });
        }
      });
    });

    _this.state = {
      isLoading: true,
      selectedServices: []
    };
    return _this;
  }

  _createClass(ServiceSelector, [{
    key: "findIfProductMatchWithTenantServices",
    value: function findIfProductMatchWithTenantServices(product, tenantServices) {
      var test = product.services.every(function (element) {
        var tenantService = tenantServices.find(function (service) {
          return service.serviceId === element.id;
        });

        if (!tenantService) {
          return false;
        }

        return true;
      });
      return test;
    }
  }, {
    key: "checkIfTenantHasServices",
    value: function checkIfTenantHasServices() {
      var _this2 = this;

      var selectedServices = [];

      if (this.props.products != null && this.props.tenantProducts != null) {
        this.props.products.forEach(function (product) {
          if (product["default"]) {
            selectedServices.push(product);

            _this2.props.change(product.name, true);
          } else {
            var found = _this2.props.tenantProducts.find(function (element) {
              return element.id == product.id;
            });

            if (found) {
              product["default"] = true;
              selectedServices.push(product);

              _this2.props.change(product.name, true);
            }
          }
        });
      } else if (this.props.products != null && this.props.tenant.tenantServices != null) {
        this.props.products.forEach(function (product) {
          if (product["default"]) {
            selectedServices.push(product);

            _this2.props.change(product.name, true);
          } else {
            var found = _this2.findIfProductMatchWithTenantServices(product, _this2.props.tenant.tenantServices);

            if (found) {
              product["default"] = true;
              selectedServices.push(product);

              _this2.props.change(product.name, true);
            }
          }
        });
      } else if (this.props.products != null && this.props.tenant.tenantServices == null) {
        this.props.products.forEach(function (product) {
          if (product["default"]) {
            selectedServices.push(product);

            _this2.props.change(product.name, true);
          }
        });
      }

      this.props.setSelectedServices(selectedServices).then(function () {
        _this2.setState({
          isLoading: false
        });
      });
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this3 = this;

      console.log("Did mount", this.props.tenantProducts);
      appInsights.trackTrace({
        message: "Onboarding | Showing Service Selector Page"
      });
      var promises = [this.props.getTenant()];
      Promise.all(promises).then(function () {
        if (_this3.props.services != null && _this3.props.services.length > 0) {
          _this3.checkIfTenantHasServices();
        } else {
          _this3.props.getServices().then(function () {
            _this3.checkIfTenantHasServices();
          });
        }
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this4 = this;

      return /*#__PURE__*/React.createElement("div", null, this.state.isLoading ? /*#__PURE__*/React.createElement(Spinner, {
        center: true
      }) : /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("h2", {
        style: {
          textAlign: 'left'
        }
      }, this.props.translate('Welcome to Haldor'), "!"), /*#__PURE__*/React.createElement("p", {
        style: {
          textAlign: 'left',
          marginTop: '1.55rem',
          marginBottom: '1.55rem'
        }
      }, this.props.translate('Start by selecting the services you want to use. If you want to use more services in the future, you can easily add them later.')), /*#__PURE__*/React.createElement("div", {
        style: {
          minHeight: '15rem',
          width: '15rem',
          marginBottom: '2rem'
        }
      }, /*#__PURE__*/React.createElement("img", {
        src: "/dist/svg/illustration_steg01.svg"
      })), /*#__PURE__*/React.createElement("div", {
        className: "form-container",
        style: {
          marginTop: '0.75rem'
        }
      }, /*#__PURE__*/React.createElement("form", {
        onSubmit: this.props.handleSubmit(this.submit),
        className: "form form-component"
      }, this.props.products && this.props.products.length > 0 ? /*#__PURE__*/React.createElement("div", null, this.props.products.map(function (element, index) {
        return /*#__PURE__*/React.createElement("div", {
          key: index,
          className: "form-row",
          style: {
            marginTop: '0.45rem'
          }
        }, /*#__PURE__*/React.createElement(Field, {
          disabled: element["default"],
          component: Checkbox,
          name: element.name,
          label: _this4.props.translate(element.name)
        }));
      })) : null, /*#__PURE__*/React.createElement("div", {
        className: "form-row spacing submit"
      }, /*#__PURE__*/React.createElement(Button, {
        type: "save"
      }, this.props.translate('Continue')))))));
    }
  }]);

  return ServiceSelector;
}(Component);

function mapStateToProps(state, ownProps) {
  var values = {};
  state.Services.selectedServices.forEach(function (element) {
    values[element.title] = true;
  });
  return {
    currentUser: state.user.currentUser,
    products: state.Services.availableProducts,
    tenantProducts: state.Services.tenantProducts,
    tenant: state.user.tenant,
    translate: translate(state.Languages.translations),
    initialValues: values
  };
}

export default connect(mapStateToProps, {
  getServices: getServices,
  setSelectedServices: setSelectedServices,
  userAdminCheck: userAdminCheck,
  updateTenantServices: updateTenantServices,
  saveSelectedProductsAsNotes: saveSelectedProductsAsNotes,
  updateTenantProducts: updateTenantProducts,
  getTenantProducts: getTenantProducts,
  getTenant: getTenant,
  createTenantServices: createTenantServices,
  change: change
})(reduxForm({
  form: 'AddService',
  destroyOnUnmount: true
})(ServiceSelector));